/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-edit[_ngcontent-%COMP%]{font-size:24px;-webkit-transform:translateY(1px);transform:translateY(1px)}.fa-dark[_ngcontent-%COMP%]{color:#666}.fa-dark[_ngcontent-%COMP%]:hover{color:#000;border:none}.fa-disabled[_ngcontent-%COMP%]{color:#cfcfcf}"];
export { styles as styles };
